import UnknownChapter from './UnknownChapter';
import NtcChapter from './NtcChapter';
import SportHubDirectory from './SportHub/Directory';
import SportHubExperience from './SportHub/Experience';
import MembershipChapter from './MembershipChapter';
import ApparelPodChapter from './ApparelPodChapter';
import MediaChapter from './MediaChapter';
import UniversalTakeoverPlayer from './UniversalTakeoverPlayer';
import ServicesMenuChapter from "./SevicesMenu/ServicesMenuChapter";
import ActivityChapter from './Activity/ActivityChapter';
import ServiceHubDirectoryChapter from './one-nike/sport-hub/DirectoryChapter';
import ServiceHubPosterChapter from './Poster/PosterChapter';


export const REGISTER = {
    unknown: UnknownChapter,
    ntc: NtcChapter,
    sport_hub_directory: SportHubDirectory,
    sport_hub_experience: SportHubExperience,
    membership: MembershipChapter,
    apparel_pod: ApparelPodChapter,
    media: MediaChapter,
    universal_takeover: UniversalTakeoverPlayer,
    services_menu: ServicesMenuChapter,
    activity: ActivityChapter,
    service_hub_menu: ServicesMenuChapter,
    service_hub_directory: ServiceHubDirectoryChapter,
    service_hub_poster: ServiceHubPosterChapter,
};

export function getChapter(key: string) {
    return REGISTER[key] || REGISTER.unknown;
}
